import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Air } from "@air/next-icons";
import { ModalCloseButton } from "@air/primitive-modal";
import { memo } from "react";
export const AirModalLogoHeader = /*#__PURE__*/ memo((param)=>{
    let { onClose } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center justify-center",
        children: [
            /*#__PURE__*/ _jsx(Air, {
                className: "mt-[-18px] h-[80px] text-blue-9"
            }),
            /*#__PURE__*/ _jsx(ModalCloseButton, {
                "data-testid": "AIR_MODAL_HEADER_CLOSE_BUTTON",
                className: "absolute right-8 top-8 size-8 shrink-0",
                size: "small",
                onClick: onClose
            })
        ]
    });
});
AirModalLogoHeader.displayName = "AirModalLogoHeader";
